import { useContext, useMemo } from 'react';
import { MutationParameters, PayloadError } from 'relay-runtime';

import { CreateListItemMutation$data } from '../graphql/__generated__/CreateListItemMutation.graphql';
import { ItemFragment$data } from '../graphql/__generated__/ItemFragment.graphql';
import { SmxPropsContext } from '../providers/propsProvider';
import { getChangeUpdateFetchKey, getSetterListItem, IListItemState } from '../store/slices/listItemSlice';
import useDispatchSetterStore from './useDispatchSetterStore';
import useDynamicSelector from './useDynamicSelector';

const useCommitItem = () => {
    const { nameList, prefixStore } = useContext(SmxPropsContext);
    const setterListItem = useDispatchSetterStore<IListItemState>(getSetterListItem(nameList + prefixStore));
    const changeUpdateFetchKey = useDispatchSetterStore<IListItemState>(
        getChangeUpdateFetchKey(nameList + prefixStore),
    );
    const parentItem = useDynamicSelector('listItem', 'parentItem');

    const getCommitItem = useMemo(
        () =>
            (
                data: ItemFragment$data,
                connectionId: string,
                id?: number,
                successAddOrEdit?: (id?: number) => void,
            ): MutationParameters => {
                return {
                    variables: {
                        input: { ...data, id },
                        connections: [connectionId],
                    },
                    onCompleted: (response: CreateListItemMutation$data, errors: PayloadError[]) => {
                        if (errors) {
                            console.log(
                                (
                                    errors[0] as PayloadError & {
                                        extensions: { debugMessage: string };
                                    }
                                ).extensions.debugMessage,
                                errors,
                            );
                            setterListItem({
                                messageError: 'Error! Duplicate name',
                            });
                        } else {
                            console.log('Item save successful', response);
                            if (!id && parentItem) {
                                setterListItem({
                                    childIdEdit: +response.createListItem?.node?.id!,
                                });
                            }
                            if (id) {
                                changeUpdateFetchKey({});
                            }
                            successAddOrEdit?.(id);
                        }
                    },
                    onError: (error: any) => {
                        console.error('Mutation error:', error);
                    },
                } as any as MutationParameters;
            },
        [],
    );

    const getCommitItemDelete = (id: number, connectionId: string): MutationParameters => {
        return {
            variables: {
                id,
                connections: [connectionId],
            },
            onCompleted: (response: any, errors: PayloadError[]) => {
                if (errors) {
                    console.log(
                        (
                            errors[0] as PayloadError & {
                                extensions: { debugMessage: string };
                            }
                        ).extensions.debugMessage,
                        errors,
                    );
                    setterListItem({
                        messageError: 'Error!',
                    });
                } else {
                    console.log('Item delete successful', response);
                    setterListItem({
                        currentEditItem: null,
                        childIdEdit: -id,
                        editMode: 'deleting',
                        spinner: false,
                    });
                }
            },
            onError: (error: any) => {
                console.error('Mutation error:', error);
            },
        } as any as MutationParameters;
    };

    return { getCommitItem, getCommitItemDelete };
};

export default useCommitItem;
